import { motion } from "framer-motion";
import { Star } from "lucide-react";
import { fadeInUp, staggerContainer } from "@/components/motionVariants";

const testimonials = [
  {
    id: "ploy",
    name: "คุณพลอย, 29",
    quote: "รู้สึกโล่งใจมาก เหมือนได้คนเข้าใจจริง ๆ และได้คำตอบที่ชัดเจนเรื่องความรัก",
  },
  {
    id: "mink",
    name: "คุณมิ้ง, 34",
    quote: "การอ่านไพ่แม่นและนุ่มนวลมากค่ะ ทำให้ตัดสินใจได้อย่างสงบ",
  },
  {
    id: "fon",
    name: "คุณฝน, 27",
    quote: "จากที่สับสนเรื่องคู่แท้ ตอนนี้รู้สึกมั่นใจขึ้นและเห็นทางชัดเจน",
  },
  {
    id: "earn",
    name: "คุณเอิร์น, 39",
    quote: "เครียดเรื่องงานและเงิน แต่ได้คำแนะนำที่ตรงจุดและอบอุ่นมาก",
  },
  {
    id: "best",
    name: "คุณเบส, 31",
    quote: "ได้มุมมองใหม่ที่ช่วยเยียวยาใจจริง ๆ เหมือนมีเพื่อนที่รับฟังอย่างจริงใจ",
  },
];

export const TestimonialsSection = () => {
  return (
    <motion.section
      id="testimonials"
      className="py-16 md:py-24"
      data-testid="testimonials-section"
      {...fadeInUp}
    >
      <div className="mx-auto max-w-md px-6 md:max-w-4xl md:px-12 lg:max-w-6xl">
        <motion.h2
          {...fadeInUp}
          className="font-serif text-3xl text-taupe md:text-4xl"
          data-testid="testimonials-title"
        >
          เสียงจริงจากผู้หญิงที่ได้รับความสบายใจ
        </motion.h2>
        <motion.p
          {...fadeInUp}
          className="mt-4 text-base text-taupeLight"
          data-testid="testimonials-subtitle"
        >
          ทุกคำพูดคือพลังใจที่บอกว่าเราอยู่เคียงข้างคุณเสมอ
        </motion.p>
        <motion.div
          variants={staggerContainer}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, amount: 0.2 }}
          className="mt-10 grid gap-6 md:grid-cols-2"
          data-testid="testimonials-grid"
        >
          {testimonials.map((testimonial) => (
            <motion.div
              key={testimonial.id}
              variants={fadeInUp}
              className="flex h-full flex-col gap-4 rounded-2xl border border-rose/30 bg-white px-6 py-8 shadow-soft"
              data-testid={`testimonial-card-${testimonial.id}`}
            >
              <div className="flex items-center gap-1" data-testid={`testimonial-stars-${testimonial.id}`}>
                {Array.from({ length: 5 }).map((_, index) => (
                  <Star
                    key={`${testimonial.id}-star-${index}`}
                    className="h-4 w-4 text-gold"
                    fill="currentColor"
                  />
                ))}
              </div>
              <p className="text-sm text-taupeLight" data-testid={`testimonial-quote-${testimonial.id}`}>
                “{testimonial.quote}”
              </p>
              <p className="text-sm font-semibold text-taupe" data-testid={`testimonial-name-${testimonial.id}`}>
                {testimonial.name}
              </p>
            </motion.div>
          ))}
        </motion.div>
      </div>
    </motion.section>
  );
};